import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { CheckBox } from "@mui/icons-material";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import dayjs from "dayjs";
export default function UserCard({
  data,
  callBack,
  selectedValue,
  countCredit,
  setDisplayErr,
  setSelectedValue,
  feature,
  requiredLabel = true
}) {
  const [checkValue, setCheckValue] = useState({});
  return (
    <Card
      sx={{
        boxShadow: "0 4px 2.3px 0 #00000026",
        m: "10px",
        p: "10px 20px",
        backgroundColor: "#EEEEFF",
        cursor: "pointer",
      }}
      onClick={feature == "bulkupload" ? () => {} : callBack}
      //   onClick={setEditedItem}
    >
      <CardContent sx={{ p: "0px 10px !important" }}>
        <Grid container>
          <Grid item xs={feature === "bulkupload" ? 8 : 12}>
            <Typography
              color="black"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {data?.name}
            </Typography>
            <Typography
              sx={{ fontSize: { xs: "11px", sm: "12px", md: "14px" } }}
            >
              {" "}
              {data?.customerMobile}
            </Typography>
            {(!!data?.birthdate || !!data?.anniversaryDate) && (
              <Typography
                sx={{
                  fontSize: { xs: "10px", sm: "13px", md: "12px" },
                  color: "primary.main",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    marginRight: "10px",
                    fontSize: { xs: "10px", sm: "13px", md: "12px" },
                  }}
                >
                  {!!data?.birthdate &&
                    `Birthday: ${dayjs(data?.birthdate).format("DD-MMM-YYYY")}`}
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontSize: { xs: "10px", sm: "13px", md: "12px" },
                    color: "primary.main",
                  }}
                >
                  {!!data?.anniversaryDate &&
                    `Anniversary: ${dayjs(data?.anniversaryDate).format(
                      "DD-MMM-YYYY"
                    )}`}
                </Typography>
              </Typography>
            )}
          </Grid>
          {feature == "bulkupload" && (
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <FormControlLabel
                value={data.customerMobile} // This is used to identify the checkbox, but it's not necessary if you are using `checked`
                checked={selectedValue.some(
                  (ele) => ele.customerMobile === data.customerMobile
                )} // Check if `data` is in selectedValue
                onChange={(e) => {
                  console.log("etttdata", data);
                  let arr = [...selectedValue];
                  let ind = arr.findIndex(
                    (ele) => ele.customerMobile === data.customerMobile
                  );

                  if (e.target.checked) {
                    // If the checkbox is checked
                    if (ind === -1 && arr.length < countCredit) {
                      // Only add if not already in the array
                      setSelectedValue([...arr, data]);
                    }
                  } else {
                    // If the checkbox is unchecked

                    if (!(arr.length < countCredit)) {
                    }
                    if (ind !== -1) {
                      // Only remove if the item is already in the array
                      arr.splice(ind, 1);
                      setSelectedValue([...arr]);
                    }
                  }
                  if (!(arr.length < countCredit)) {
                    setDisplayErr((prev) => {
                      let data = { ...prev };
                      data.status = true;
                      data.Msg = "Insufficient credits to send more messages.";
                      return data;
                    });
                  } else {
                    setDisplayErr((prev) => {
                      let data = { ...prev };
                      data.status = false;
                      data.Msg = "Insufficient credits to send more messages.";
                      return data;
                    });
                  }
                  if (!(arr.length < countCredit)) {
                    setDisplayErr((prev) => {
                      let data = { ...prev };
                      data.status = true;
                      data.Msg = "Insufficient credits to send more messages.";
                      return data;
                    });
                  } else {
                    setDisplayErr((prev) => {
                      let data = { ...prev };
                      data.status = false;
                      data.Msg = "Insufficient credits to send more messages.";
                      return data;
                    });
                  }
                }}
                sx={{ margin: 0 }}
                required={requiredLabel}
                control={<Checkbox />} // No need for defaultChecked here since we control the checked state via selectedValue
                label={requiredLabel ? "Required" : ""}
              />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
